import { PadSessionStage } from "@/interfaces/virtualPad_types"

export interface ISessionProtocol {
  whoami: () => string
  create: () => void
  waitUntilCreated: () => Promise<void>
  sendOffer: (connectionId: string, sdp: string) => void
  sendIceCandidate: (connectionId: string, candidate: RTCIceCandidateInit) => void
  close: () => void
  handleMessage: (e: MessageEvent) => void
  reset: () => void
  getStage: () => PadSessionStage
  getSessionId: () => string | null
  getHostConnectedId: () => string | null
}

export class SessionProtocolStrategy {
  private readonly sessionProtocol: ISessionProtocol

  constructor (protocol: ISessionProtocol) {
    this.sessionProtocol = protocol
  }

  whoami (): void {
    this.sessionProtocol.whoami()
  }

  create (): void {
    this.sessionProtocol.create()
  }

  /**
   * Waits until the active protocol creates the session
   */
  waitUntilCreated (): Promise<void> {
    return this.sessionProtocol.waitUntilCreated()
  }

  sendOffer (connectionId: string, sdp: string): void {
    this.sessionProtocol.sendOffer(connectionId, sdp)
  }

  sendIceCandidate (connectionId: string, candidate: RTCIceCandidateInit): void {
    this.sessionProtocol.sendIceCandidate(connectionId, candidate)
  }

  close (): void {
    this.sessionProtocol.close()
  }

  handleMessage (e: MessageEvent) {
    this.sessionProtocol.handleMessage(e)
  }

  reset (): void {
    this.sessionProtocol.reset()
  }

  getSessionId (): string | null {
    return this.sessionProtocol.getSessionId()
  }

  getHostConnectedId (): string | null {
    return this.sessionProtocol.getHostConnectedId()
  }

  getStage (): PadSessionStage {
    return this.sessionProtocol.getStage()
  }
}
